import axios from "axios";
import { ApiKey, BaseUrl } from "../global";

export const getInternationalCNs = async (data) => {
    try {
        debugger
        const rs = await axios.post(BaseUrl + 'api/InternationalAddressLabel/GetInternationalCNs', data, {
            headers: {
                key: ApiKey
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}


export const generateInternationalAddressLabels = async (data) => {
    try {
        debugger
        const rs = await axios.post(BaseUrl + 'api/InternationalAddressLabel/GenerateInternationalAddressLabels', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}